import importerStore from '@shared/importer/importer-store';
import { ClubService } from '@modules/club/club-service';
import clubImporterFields from '@modules/club/club-importer-fields';
import { i18n } from '@shared/i18n';

export default importerStore(
  ClubService.import,
  clubImporterFields,
  i18n('entities.club.importer.fileName'),
  i18n('entities.club.importer.hint'),
);
